import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';

export const determineITAdmin = (user: any) => {
  let admin = false;
  user.roles.forEach((role) => {
    //console.log('role: ', role);
    if (role.isAdmin) admin = true;
  });
  return user.currentRole.departmentId === 19 || admin;
};
